export class PrintLabel {
    invNo: string;
    description: string;
    purchaseDate: Date;
    sapCode: string;
    serialNumber: string;
    company: string;
}